import { render } from "./QualificationView.vue?vue&type=template&id=8a5465b8&scoped=true"
import script from "./QualificationView.vue?vue&type=script&lang=js"
export * from "./QualificationView.vue?vue&type=script&lang=js"

import "./QualificationView.vue?vue&type=style&index=0&id=8a5465b8&scoped=true&lang=scss"
import "./QualificationView.vue?vue&type=style&index=1&id=8a5465b8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a5465b8"]])

export default __exports__